import React from 'react';

const domain = process.env.API_PROTOCOL + '://' + process.env.API_DOMAIN;
const registerUrl = domain + '/wp-json/freespin/v1/register';
const activationUrl = domain + '/wp-json/freespin/v1/activation';
const loginUrl = domain + '/wp-json/jwt-auth/v1/token';
const balanceUrl = domain + '/wp-json/freespin/v1/balance';
export {domain, registerUrl, activationUrl, loginUrl, balanceUrl};